export interface Notification {
   id?: string;
   message?: string;
   type?: NotificationType;
   is_infinite?: boolean;
}

export enum NotificationType {
   Success = 'Success',
   Error = 'Error',
   Warning = 'Warning',
   Info = 'Info',
}

export enum NotificationIcon {
   Success = 'fa-check',
   Error = 'fa-triangle-exclamation',
   Warning = 'fa-triangle-exclamation',
   Info = 'fa-spinner-third fa-spin',
}

export enum NotificationBackground {
   Success = 'var(--nxt-green)',
   Error = 'var(--nxt-red)',
   Warning = 'var(--nxt-yellow)',
   Info = 'var(--nxt-light-grey)',
}
